export async function getCityName(latitude: number, longitude: number): Promise<string> {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY_GEOCODING; 
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}&language=de`;
  
    try {
      const response = await fetch(url);
      const data = await response.json();
  
      if (data.status === 'OK') {
        for (const result of data.results) {
          for (const component of result.address_components) {
            if (component.types.includes('locality')) {
              return component.long_name;
            }
          }
        }
        return 'Ort nicht gefunden';
      } else {
        console.error('Geocoding API Fehler:', data.status, data.error_message);
        return 'Fehler bei der API Standortbestimmung';
      }
    } catch (error) {
      console.error('Netzwerkfehler:', error);
      return 'Fehler bei der Standortbestimmung';
    }
  }
  